// extracted by mini-css-extract-plugin
export var loanCardsSection = "bn_dV";